import { Box, Grid, Modal } from '@mui/material';
import { Formik } from 'formik';
import React from 'react';
import { TextFieldWrapper } from '.';
import { validationSchema } from '../constants/validationSchema';
import * as yup from 'yup';
import { ApiManager } from '../services/api';
import useNotification from '../hooks/useNotification';

function MessagePopup({
  close = () => {},
  onSuccess = () => {},
  open = false,
  receivers = [],
  bidId = '',
  tenderId = '',
  replyTo = '',
}) {
  const { successNonification, errorNonification } = useNotification();

  return (
    <Modal
      open={open}
      onClose={() => {
        close();
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: 300,
          bgcolor: '#fff',
          borderRadius: '10px',
          boxShadow: 24,
          p: 2,
        }}
      >
        <div className="text-lg font-bold">New Message</div>
        <Formik
          initialValues={{
            title: '',
            message: '',
          }}
          validationSchema={yup.object().shape({
            message: validationSchema.required('Message'),
          })}
          onSubmit={async (values, actions) => {
            try {
              const data = new FormData();
              data.append('title', values?.title || '');
              data.append('message', values?.message || '');
              if (Array.isArray(receivers)) {
                receivers.map((item, index) =>
                  data.append(`receivers[${index}]`, item)
                );
              } else {
                data.append(`receivers[0]`, receivers);
              }
              data.append('bid', bidId);
              data.append('tender', tenderId);
              if (replyTo) {
                data.append('replyTo', replyTo);
              }

              const res = await ApiManager.sendMessage(data);
              if (res?.status === 200) {
                successNonification('Message sent');
                onSuccess();
                close();
              } else {
                errorNonification(
                  res?.data?.message || 'Something went wrong.'
                );
              }
            } catch (error) {
              console.log(error);
            }
          }}
        >
          {({
            values,
            touched,
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="flex flex-col gap-2">
                  <label className="text-xs">Title</label>
                  <TextFieldWrapper
                    placeholder="Placeholder"
                    autoFocus
                    name="title"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.title}
                    helperText={touched.title && errors.title}
                    error={!!touched.title && !!errors.title}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className="flex flex-col gap-2">
                  <label className="text-xs">
                    Message <span className="text-red-500">*</span>
                  </label>
                  <TextFieldWrapper
                    placeholder="Placeholder"
                    multiline
                    minRows={5}
                    name="message"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.message}
                    helperText={touched.message && errors.message}
                    error={!!touched.message && !!errors.message}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className="flex items-center justify-between mt-8">
                  <button
                    onClick={close}
                    className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleSubmit}
                    className="text-xs bg-main text-white text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                  >
                    Send
                  </button>
                </div>
              </Grid>
            </Grid>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export default MessagePopup;
